module.exports = __webpack_public_path__ + "static/media/Tormund Giantsbane 2.61e78811.jpg";